import { Icon, UploadAreaUI } from '@fourthwall/components';
import { PlusIcon } from '@fourthwall/icons';
import React from 'react';
import * as S from './styled';
const EmptyStateUploadZone = (props) => (React.createElement(UploadAreaUI.ContentWrapper, { disabled: false, invalid: false, size: "large", ...props },
    React.createElement(S.Container, null,
        React.createElement(UploadAreaUI.Hero, { size: "large", orientation: "vertical" },
            React.createElement(S.Stack, { space: 12 },
                React.createElement(Icon, { component: PlusIcon, height: 24 }),
                React.createElement(S.Stack, { space: 8 },
                    React.createElement(S.Title, null,
                        "Drag and drop images or ",
                        React.createElement("u", null, "browse")),
                    React.createElement(S.Subtitle, null, "Recommended 3:4 aspect ratio, at least 600px wide")))))));
export const renderEmptyStateUploadZone = (props) => (React.createElement(EmptyStateUploadZone, { ...props }));
